import React from 'react';

import shapeImg1 from '../../assets/img/about/shape-1-2.png';
import shapeImg2 from '../../assets/img/choose/shape-1-2.png';
import shapeImg3 from '../../assets/img/about/shape-1-1.png';
import aboutImg1 from '../../assets/img/about/about-1-1.jpg';
import aboutImg2 from '../../assets/img/about/about-1-2.jpg';
import aboutImg3 from '../../assets/img/about/about-1-3.jpg';
import aboutImg4 from '../../assets/img/about/about-1-4.jpg';
import aboutImg5 from '../../assets/img/about/about-1-5.jpg';
import avatarImg from '../../assets/img/about/avatar.png';
import avatarImged from '../../assets/img/about/ed1.jpg';
import abtImg1 from '../../assets/img/about/abt1.jpg';
import abtImg2 from '../../assets/img/about/abt2.jpg';
import abtImg3 from '../../assets/img/about/abt3.jpg';
import abtImg4 from '../../assets/img/about/abt4.jpg';
import abtImg5 from '../../assets/img/about/abt5.jpg';

const About = () => {
  return (
    <div className="it-about-area p-relative fix z-index pt-120 pb-120">
      <div className="it-about-shape-2">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="it-about-shape-3 d-none d-xxl-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div
            className="col-xl-5 col-lg-6 col-md-10 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="it-about-left">
              <div className="it-about-thumb-wrap p-relative d-flex justify-content-between align-items-center">
                <div className="it-about-thumb thumb-1">
                  <img src={abtImg1} alt="" style={{ width: '200px', height: 'auto' , paddingRight: '10px',  paddingLeft: '10px'}}/>
                </div>
                <div className="it-about-thumb-box">
                  <div className="it-about-thumb thumb-2">
                    <img src={abtImg2} alt="" style={{ width: '200px', height: 'auto' , paddingRight: '10px',  paddingLeft: '10px' }} />
                  </div>
                  <div className="it-about-thumb thumb-3">
                    <img src={abtImg3} alt="" style={{ width: '200px', height: 'auto' , paddingRight: '10px',  paddingLeft: '10px'}}/>
                  </div>
                </div>
                <div className="it-about-thumb-box m-0">
                  <div className="it-about-thumb thumb-4">
                    <img src={abtImg4} alt="" style={{ width: '200px', height: 'auto' , paddingRight: '10px',  paddingLeft: '10px'}}/>
                  </div>
                  <div className="it-about-thumb thumb-5">
                    <img src={abtImg5} alt="" style={{ width: '200px', height: 'auto' , paddingRight: '10px',  paddingLeft: '10px'}}/>
                  </div>
                </div>
                <div className="it-about-shape-1">
                  <img src={shapeImg3} alt="" style={{ width: '200px', height: 'auto' , paddingRight: '10px',  paddingLeft: '10px'}}/>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-7 col-lg-6 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="it-about-right">
              <div className="it-about-title-box mb-20">
                <span className="it-section-subtitle">MORE ABOUT US</span>
                <h3 className="it-section-title">
                Providing Exceptional Healthcare  
                <br />
                for <span>All</span>
                </h3>
              </div>
              <div className="it-about-text mb-30">
                <p>
                The Rawalpindi Institute of Cardiology (RIC) is a government hospital dedicated to providing exceptional cardiac care to patients. Equipped with state-of-the-art facilities and staffed by experienced professionals, we ensure world-class treatment for every heart. At RIC, we are committed to saving lives and improving heart health with compassion and excellence.
                </p>
              </div>
              <div className="it-about-list-wrap mb-45">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="it-about-list style-1">
                      <ul>
                        <li>
                          <i className="flaticon-check-mark"></i>Disease Prevention
                        </li>
                        <li>
                          <i className="flaticon-check-mark"></i>Early Diagnosis & Treatment
                        </li>
                        <li>
                          <i className="flaticon-check-mark"></i>Best Technology
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="it-about-list style-2">
                      <ul>
                        <li>
                          <i className="flaticon-check-mark"></i>Improved Quality of Life
                        </li>
                        <li>
                          <i className="flaticon-check-mark"></i>Emergency Care & Trauma Services
                        </li>
                        <li>
                          <i className="flaticon-check-mark"></i>Advanced Medical
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="it-about-bottom flex-wrap d-sm-flex align-items-center">
                <div className="it-about-author-info d-flex align-items-center">
                <div className="it-about-author-thumb">
                  <img 
                    src={avatarImged} 
                    alt="Author" 
                    style={{ width: '70px', height: 'auto', borderRadius: '50%' }} 
                  />
                </div>
                  <div className="it-about-author-text">
                    <h5>Dr Musfirah Siddique</h5>
                    <span>Executive Director (ED)</span>
                  </div>
                </div>
                <div className="it-about-tel-box d-flex align-items-center">
                  <div className="it-about-tel-icon">
                    <span>
                      <i className="flaticon-phone-call"></i>
                    </span>
                  </div>
                  <div className="it-about-tel-text">
                    <span>Need help?</span>
                    <a href="tel:+92-51-9281111-9">+92-51-9281111-9</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
